// @ts-check
import { Trans } from '@lingui/macro';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../components/Layout/Footer';
import Layout from '../../../../components/Layout/Layout';
import Main from '../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../components/Layout/PageHeader';
import ValidateIdentifier, {
  useIdentifierValidation,
} from '../identifierValidation/identifierValidation';
import {
  ProgressIndicator,
  bottlebooksFieldsSource,
  fieldsToImport,
  useLink,
} from './_config';

export default function IdentifierValidation({ match }) {
  const link = useLink('identifierValidation');
  const { workspaceId, importId } = match.params;
  const props = useIdentifierValidation({ workspaceId, importId });

  return (
    <Layout>
      <ProgressIndicator step="mapData" />
      <PageHeader>
        <PageTitle>
          <Trans>Data Validation</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>Ensure your data is valid and ready to import.</Trans>
        </PageSubtitle>
      </PageHeader>
      <Main>
        <ValidateIdentifier
          {...props}
          masterListColumns={[...fieldsToImport, ...bottlebooksFieldsSource]}
        />
      </Main>
      <Footer>
        <BackButton to={link.back()} />
        <CancelButton to={link.cancel()} />
        <NextButton to={link.next()} disabled={!props.isValid}>
          <Trans>Next</Trans>
        </NextButton>
      </Footer>
    </Layout>
  );
}
